import React, { Component } from 'react';
import { Grid, Form, Button } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import _ from 'lodash';
import moment from 'moment';

import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { TIME_FORMAT_UI } from './../../helper';
import 'Styles/pages/inventory/truckrouteschedule/index.less';

class TruckRouteTimeComponent extends Component {
  handleChange = (selectedTime, index) => {
    this._calander.setOpen(false);
    const { input } = this.props;
    const cloneInput = [...input.value];
    cloneInput[index] = moment(selectedTime).format(TIME_FORMAT_UI);
    input.onChange(cloneInput);
  };
  onAddClick = index => {
    const { input } = this.props;
    const cloneInput = [...input.value];
    cloneInput.splice(index + 1, 0, GenericEnum.EmptyString);
    input.onChange(cloneInput);
  };
  onDeleteClick = index => {
    const { input } = this.props;
    const cloneInput = [...input.value];
    if (index === 0 && cloneInput.length <= 1) {
      cloneInput.splice(index, 1, GenericEnum.EmptyString);
    } else {
      cloneInput.splice(index, 1);
    }
    input.onChange(cloneInput);
  };

  render() {
    const { input } = this.props;
    return (
      <Form.Field>
        <Grid>
          {_.map(input.value, (time, index) => {
            return (
              <Grid.Row columns={3} key={index}>
                <Grid.Column width={2}>Slot {index + 1} :</Grid.Column>
                <Grid.Column width={4} className={'time-picker-custom'}>
                  <DatePicker
                    value={time}
                    dropdownMode="select"
                    onChange={selectedTime => {
                      this.handleChange(selectedTime, index);
                    }}
                    ref={r => (this._calander = r)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={30}
                    dateFormat={TIME_FORMAT_UI}
                    timeCaption="Time"
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Button
                    icon="plus"
                    type={'button'}
                    disabled={!time}
                    onClick={() => this.onAddClick(index)}
                  />
                  <Button
                    icon="minus"
                    type={'button'}
                    disabled={!time}
                    onClick={() => this.onDeleteClick(index)}
                  />
                </Grid.Column>
              </Grid.Row>
            );
          })}
        </Grid>
      </Form.Field>
    );
  }
}

export default TruckRouteTimeComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/components/createedittruckrouteschedule/TruckRouteTimeComponent.js